import { Select } from 'antd'

import { INSURANCE_OPTIONS } from '@/src/data'

import type { SelectProps } from 'antd'
import { getClientDefaultInsurance } from '@/src/api'

interface InsuranceSelectProps {
  value?: string
  onChange?: (value: string) => void
}

export const InsuranceSelect = ({ value, onChange }: InsuranceSelectProps) => {
  const handleChange: SelectProps['onChange'] = (value) => {
    onChange?.(value as string)
  }

  // Get the default insurance for the client from the session
  const defaultInsurance =
    typeof window !== 'undefined' ? getClientDefaultInsurance() : null

  // If there is a default insurance, add it as the only option
  // Otherwise, use the default options
  const options = defaultInsurance
    ? [{ value: defaultInsurance, label: defaultInsurance }]
    : [...INSURANCE_OPTIONS].sort((a, b) => a.label.localeCompare(b.label))

  return (
    <Select
      data-testid='insurance-select'
      className='custom-insurance-select'
      showSearch
      placeholder='Select an insurance'
      options={options}
      disabled={!!defaultInsurance}
      onChange={handleChange}
      value={value || defaultInsurance || undefined}
      popupClassName='custom-insurance-select-dropdown'
    />
  )
}
